/**
 * Alpine x directive utility for adding a sumission animation to the submit button
 */

const SubmitAnimateFormBuilder = function(el, { value, modifiers, expression }, { Alpine }) {

  const addAnimateElement = submitButton => {
    submitButton.classList.add('button-animate-submit');

    const buttonLabelSpan = document.createElement('span');

    buttonLabelSpan.classList.add('button-label');
    buttonLabelSpan.textContent = submitButton.textContent;

    const animationSpan = document.createElement('span');

    animationSpan.classList.add('submit-animation');

    submitButton.innerHTML = '';

    submitButton.appendChild(animationSpan);
    submitButton.appendChild(buttonLabelSpan);
  }

  const submitButtonElement = el.querySelector("form.FormBuilder [type='submit']");

  // Add on initial DOM load
  addAnimateElement(submitButtonElement);


  // Set mutation observer to add on DOM update
    /**
   * Observer for all child elements of the x-directive element
   */
  const domUpdateObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach(mutation => {
      if (
        !mutation.addedNodes.length ||
        mutation.addedNodes.length > 1 ||
        mutation.addedNodes[0].nodeName === '#text'
      ) {
        return;
      }

      const addedNode = mutation.addedNodes[0];

      if (!addedNode.hasAttribute('data-formbuilder-htmx')) {
        return;
      }

      const submitButtonElement = addedNode.querySelector("form.FormBuilder [type='submit']");

      addAnimateElement(submitButtonElement);
    });
  });

  domUpdateObserver.observe(el, {childList: true, subtree: true});
}

export default SubmitAnimateFormBuilder;
